import { withErrorBoundary } from "@sentry/nextjs";
import { CSSProperties, FC } from "react";
import styled from "styled-components";
import { StarsContainer } from "./StarsContainer";

type Props = {
  tag: string;
  cardTitleBackground: string;
  featureTag?: string;
  featureTagBackground?: string;
  featureTagColor?: string;
};

const Pricing5CardHeader: FC<Props> = withErrorBoundary(
  ({ tag, featureTag = "", featureTagColor = "", featureTagBackground = "", cardTitleBackground }) => {
    return (
      <StyledPricing5Header style={{ "--background-color": cardTitleBackground } as CSSProperties}>
        <div className="Font_18_26_700">{tag}</div>

        {featureTag && (
          <StarsContainer
            color={featureTagColor}
            backgroundColor={featureTagBackground}
            className="Pricing5__starsContainer Font_16_22_700"
          >
            {featureTag}
          </StarsContainer>
        )}
      </StyledPricing5Header>
    );
  },
  {}
);

const StyledPricing5Header = styled.div`
  display: flex;
  gap: 8px;
  justify-content: space-between;
  padding: 12px 24px;
  background-color: var(--background-color);
  border-radius: 8px 8px 0 0;

  .Pricing5__starsContainer {
    padding: 2px 8px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    padding: 12px 16px;

    .Stars__icon {
      display: none;
    }
  }
`;

export { Pricing5CardHeader };
